export enum FinancialDataType {
  PLANNING = "PLANNING",
  PURCHASE_ORDER = "PURCHASE_ORDER",
  INVOICE = "INVOICE",
  EXPENSE_REPORT_EXPENSE = "EXPENSE_REPORT_EXPENSE",
  OFFER = "OFFER",
  CONTRACT_INVOICE = "CONTRACT_INVOICE",
  MANUAL_ENTRY = "MANUAL_ENTRY",
}

export enum FinancialDataCategory {
  MATERIAL = "MATERIAL",
  INTERNAL_WORKFORCE = "INTERNAL_WORKFORCE",
  EXTERNAL_WORKFORCE = "EXTERNAL_WORKFORCE",
  SUBCONTRACTOR = "SUBCONTRACTOR",
  MANUAL_PURCHASE = "MANUAL_PURCHASE",
  MANUAL_WORFORCE = "MANUAL_WORFORCE",
  MANUAL_OTHER = "MANUAL_OTHER",
}

export enum FinancialDataTypeLabel {
  PLANNING = "Planning",
  PURCHASE_ORDER = "Bon de commande",
  INVOICE = "Facture",
  EXPENSE_REPORT_EXPENSE = "Note",
  OFFER = "Offre",
}

export class FinancialData {
  data_id: string;
  type: FinancialDataType;
  category: FinancialDataCategory;
  linked_to_id: string;
  linked_to_projects: string[];
  corporate_id: string;
  issuer_name: string;
  content: string;
  currency: string;
  consumed_amount_bt: number;
  consumed_amount_pt: number;
  projected_amount_bt: number;
  projected_amount_pt: number;
  fc_amount: number;
  amount_due: number;
  invoiced_percent: number;
  added_date: Date;
  deadline_date: Date;
  status: string;
  is_contract_invoice: boolean;
  financialDatas: FinancialData[] = [];

  // not in db

  custom_search_field_corporates_ids: string;
  custom_search_field_amounts_bt: string;

  constructor() {
    this.linked_to_projects = [];
  }

  public static createInstance(jsonData: FinancialData): FinancialData {
    const p = Object.assign(new FinancialData(), jsonData);
    p.added_date = jsonData.added_date ? new Date(jsonData.added_date) : null;
    p.deadline_date = jsonData.deadline_date ? new Date(jsonData.deadline_date) : null;

    if (jsonData.financialDatas) {
      p.financialDatas = FinancialData.createInstances(jsonData.financialDatas);
    }

    return p;
  }

  public static createInstances(jsonData: FinancialData[]): FinancialData[] {
    return jsonData.map(FinancialData.createInstance);
  }
}
